import { OnInit, EventEmitter } from '@angular/core';
import { ReportGroup, ReportObject, PageContent } from 'src/app/objects/WorkObject';
import { DomSanitizer } from '../../../node_modules/@angular/platform-browser';
import { WorkspaceService } from '../services/workspace.service';
var ReportgroupComponent = /** @class */ (function () {
    function ReportgroupComponent(sanitizer, workspaceService) {
        this.sanitizer = sanitizer;
        this.workspaceService = workspaceService;
        this.variables = {};
        this.msGridColumns = "";
        this.msGridRows = "";
        this.gridColumnsDefaultArray = [];
        this.gridRowsDefaultArray = [];
        this.dialog = false;
        this.emitReportGroup = new EventEmitter();
        this.getRelatedEpics = new EventEmitter();
        this.setFixedHeight = new EventEmitter();
    }
    Object.defineProperty(ReportgroupComponent.prototype, "getReportGroup", {
        set: function (content) {
            var _this = this;
            this.promiseGetEpicGroup(content.EPICPageId, content.EPICContentId).then(function (result) {
                var reportGroup = JSON.parse(result);
                _this.reportGroup = JSON.parse(result);
                _this.reportGroup.StartRow = _this.posY == 0 ? 1 : _this.posY;
                _this.reportGroup.StartColumn = _this.posX == 0 ? 1 : _this.posX;
                _this.sortReports(_this.reportGroup.EPICs);
                _this.setStartRow(_this.reportGroup.EPICs);
                _this.setStartColumn(_this.reportGroup.EPICs);
                _this.gridColumnsDefaultArray = Array(_this.reportGroup.Width).fill("1fr");
                _this.gridRowsDefaultArray = Array(_this.reportGroup.Height).fill("minmax(0px, 1fr)");
                _this.reportGroup.EPICs.filter(function (x) { return x.FixWidth > 0; }).forEach(function (epic) {
                    _this.constructGridColumns(epic);
                });
                _this.reportGroup.EPICs.filter(function (x) { return x.FixHeight > 0; }).forEach(function (epic) {
                    _this.constructGridRows(epic);
                });
                _this.buildUltimateGridColumns();
                _this.buildUltimateGridRows();
                _this.emitReportGroup.emit(_this.reportGroup);
            });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ReportgroupComponent.prototype, "setReportGroup", {
        set: function (reportGroup) {
            var _this = this;
            this.reportGroup = reportGroup;
            this.sortReports(this.reportGroup.EPICs);
            this.setStartRow(this.reportGroup.EPICs);
            this.setStartColumn(this.reportGroup.EPICs);
            this.gridColumnsDefaultArray = Array(this.reportGroup.Width).fill("1fr");
            this.gridRowsDefaultArray = Array(this.reportGroup.Height).fill("minmax(0px, 1fr)");
            this.reportGroup.EPICs.filter(function (x) { return x.FixWidth > 0; }).forEach(function (epic) {
                _this.constructGridColumns(epic);
            });
            this.reportGroup.EPICs.filter(function (x) { return x.FixHeight > 0; }).forEach(function (epic) {
                _this.constructGridRows(epic);
            });
            this.buildUltimateGridColumns();
            this.buildUltimateGridRows();
        },
        enumerable: true,
        configurable: true
    });
    ReportgroupComponent.prototype.ngOnInit = function () {
    };
    ReportgroupComponent.prototype.promiseGetEpicGroup = function (epicPageId, groupId) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.workspaceService.getEPICGroup(epicPageId, groupId).subscribe(function (result) {
                resolve(result);
            });
        });
    };
    ReportgroupComponent.prototype.constructGridColumns = function (report) {
        var startColumn = report.StartColumn - 1;
        for (var i = 0; i < report.Width; i++) {
            this.gridColumnsDefaultArray[startColumn] = report.FixWidth / report.Width + "px";
            startColumn++;
        }
    };
    ReportgroupComponent.prototype.constructGridRows = function (report) {
        var startRow = report.StartRow - 1;
        for (var i = 0; i < report.Height; i++) {
            this.gridRowsDefaultArray[startRow] = report.FixHeight / report.Height + "px";
            startRow++;
        }
    };
    ReportgroupComponent.prototype.buildUltimateGridRows = function () {
        var _this = this;
        var ultimateRows = "";
        var msUltimateRows = "";
        var array = this.gridRowsDefaultArray.map(function (item) { return item; }).filter(function (value, index, self) { return self.indexOf(value) === index; }); //remove duplicates
        this.setFixedHeight.emit(this.gridRowsDefaultArray);
        array.forEach(function (element) {
            ultimateRows = ultimateRows + "repeat(" + _this.gridRowsDefaultArray.filter(function (x) { return x == element; }).length + ", " + element + ") ";
            for (var i = 0; i < _this.gridRowsDefaultArray.filter(function (x) { return x == element; }).length; i++) {
                msUltimateRows = msUltimateRows + element + " ";
            }
        });
        this.gridRows = ultimateRows;
        this.msGridRows = msUltimateRows;
    };
    ReportgroupComponent.prototype.buildUltimateGridColumns = function () {
        var _this = this;
        var ultimateColumns = "";
        var msUltimateColumns = "";
        var array = this.gridColumnsDefaultArray.map(function (item) { return item; }).filter(function (value, index, self) { return self.indexOf(value) === index; }); //remove duplicates
        array.forEach(function (element) {
            ultimateColumns = ultimateColumns + "repeat(" + _this.gridColumnsDefaultArray.filter(function (x) { return x == element; }).length + ", " + element + ") ";
            for (var i = 0; i < _this.gridColumnsDefaultArray.filter(function (x) { return x == element; }).length; i++) {
                msUltimateColumns = msUltimateColumns + element + " ";
            }
        });
        this.gridColumns = ultimateColumns;
        this.msGridColumns = msUltimateColumns;
    };
    ReportgroupComponent.prototype.setStartColumn = function (report) {
        var startLine = 0; // start at line 0
        var endLine = 1; // end at line 1
        report.forEach(function (x) {
            x.StartColumn = startLine + endLine;
            endLine = x.StartColumn + x.Width;
            if (x.BreakAfter) {
                endLine = 1;
            }
        });
    };
    ReportgroupComponent.prototype.setStartRow = function (report) {
        var startRow = 1;
        report.forEach(function (x) {
            x.StartRow = startRow;
            if (x.BreakAfter)
                startRow = startRow + x.Height;
        });
    };
    ReportgroupComponent.prototype.getRelatedEpic = function (event) {
        this.getRelatedEpics.emit(event);
    };
    ReportgroupComponent.prototype.UpdateVariable = function (event) {
        var tempVariables = Object.assign({}, this.variables); //just to trigger angular !
        Object.keys(event).forEach(function (x) {
            tempVariables[x] = event[x];
        });
        this.variables = tempVariables;
    };
    ReportgroupComponent.prototype.sortReports = function (report) {
        this.reportGroup.EPICs = report.sort(function (a, b) {
            if (a.GroupSequence > b.GroupSequence) {
                return 1;
            }
            else if (a.GroupSequence < b.GroupSequence) {
                return -1;
            }
            else {
                return 0;
            }
        });
    };
    ReportgroupComponent.prototype.togglePanel = function (bool, report) {
        this.reportGroup.EPICs.find(function (x) { return x.EPICId == report.EPICId; }).IsCollapsed = bool;
        var relatedReport = this.findRelatedEPICs(report, bool);
        var endColumn = report.Width + report.StartColumn - 1;
        if (bool) {
            // fix hidden width panel
            for (var i = report.StartColumn - 1; i < endColumn; i++) {
                var columnWidth = (20 / report.Width) + "px";
                this.gridColumnsDefaultArray[i] = columnWidth;
            }
        }
        else {
            if (report.FixWidth > 0) {
                this.constructGridColumns(report);
            }
            else if (relatedReport) {
                if (relatedReport.FixWidth > 0) {
                    this.constructGridColumns(relatedReport);
                }
            }
            else {
                for (var i = report.StartColumn - 1; i < endColumn; i++) {
                    this.gridColumnsDefaultArray[i] = "1fr";
                }
            }
        }
        this.buildUltimateGridColumns();
    };
    ReportgroupComponent.prototype.findRelatedEPICs = function (report, bool) {
        if (this.reportGroup.EPICs.find(function (x) { return x.EPICId == report.EPICId; }).TemplateType == "ViewList") {
            if (this.reportGroup.EPICs.find(function (x) { return x.TemplateType == "QuickLinks"; })) {
                this.reportGroup.EPICs.find(function (x) { return x.TemplateType == "QuickLinks"; }).IsCollapsed = bool;
                return this.reportGroup.EPICs.find(function (x) { return x.TemplateType == "QuickLinks"; });
            }
        }
    };
    return ReportgroupComponent;
}());
export { ReportgroupComponent };
